import React from "react"
import { Card, CardText, CardTitle, Col, Row, Table } from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import ScrollBar from "react-perfect-scrollbar"
import CheckboxType from "pages/Inspection/CheckboxType"
import DropdownType from "pages/Inspection/DropdownType"
import TextInputType from "pages/Inspection/TextInputType"
import RadioType from "pages/Inspection/RadioType"

function Pants(props) {
  const dispatch = useDispatch()
  const store = useSelector(state => state)
  const pants = store.inspection.orderSize.data?.pants

  if (!pants) return null

  return (
    <Card body>
      <ScrollBar style={{ height: 585, position: "relative" }}>
        <div style={{ width: 800 }}>
          <Row>
            <Col md="6">
              <div className="fw-bold">寸法</div>
              <div>
                <Table bordered striped>
                  <tbody>
                    {pants.dimensions.map((i, k) => (
                      <tr key={k}>
                        <td>{i.item}</td>
                        <td>{i.nude}</td>
                        <td>{i.correctionValue}</td>
                        <td>{i.riseDimension}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
            <Col md="6">
              <div className="fw-bold">補正</div>
              <div>
                <Table bordered striped>
                  <tbody>
                    {pants.corrections.map((i, k) => (
                      <tr key={k}>
                        <td>{i.item}</td>
                        <td>
                          {i.format == "チェックボックス" && (
                            <CheckboxType answers={i.answers} />
                          )}

                          {i.format == "プルダウン" && (
                            <DropdownType answers={i.answers} />
                          )}
                          {i.format == "TEXT" && (
                            <TextInputType answers={i.answers} />
                          )}

                          {i.format == "ラジオボタン" && (
                            <RadioType answers={i.answers} />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <div className="fw-bold">仕様枠</div>
              <div>
                <Table bordered striped>
                  <tbody>
                    {pants.specifications.map((i, k) => (
                      <tr key={k}>
                        <td>{i.item}</td>
                        <td>
                          {i.format == "チェックボックス" && (
                            <CheckboxType answers={i.answers} />
                          )}

                          {i.format == "プルダウン" && (
                            <DropdownType answers={i.answers} />
                          )}
                          {i.format == "TEXT" && (
                            <TextInputType answers={i.answers} />
                          )}

                          {i.format == "ラジオボタン" && (
                            <RadioType answers={i.answers} />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </div>
      </ScrollBar>
    </Card>
  )
}

export default Pants
